import { styled } from '@mui/material/styles'
import { Box } from '@mui/material'


export const LegendContainer = styled(Box)`
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 16px;
  padding: 8px 0 12px 0;
  margin-bottom: 8px;
`

export const LegendItem = styled(Box)`
  display: flex;
  align-items: center;
  gap: 4px;
`

export const LegendColor = styled(Box)(props => `
  width: ${props.type === 'brand' ? '20' : '12'}px;
  height: ${props.type === 'brand' ? '20' : '12'}px;
  border-radius: 50%;
  border: ${props.type === 'brand' ? 1 : 0 }px solid #333;
  background-color: ${props.bgColor || 'white'};
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 400;
  color: ${props.textColor || props.color};
  flex-shrink: 0;
`)

